import React from 'react';
import { SEO } from '../components/SEO';
import { organizationSchema, localBusinessSchema, serviceSchema, websiteSchema, breadcrumbSchema, faqSchema, reviewSchema } from '../utils/structuredData';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsGrid } from '../components/BenefitsGrid';
import { ProcessSteps } from '../components/ProcessSteps';
import { ServicesSection } from '../components/ServicesSection';
import { CaseStudies } from '../components/CaseStudies';
import { Testimonials } from '../components/Testimonials';
import { PricingSection } from '../components/PricingSection';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  // FAQ Structured Data
  const faqData = [{
    question: 'Wie lange dauert die Close CRM Implementierung?',
    answer: 'Die Implementierung dauert in der Regel 2-4 Wochen, abhängig vom gewählten Paket. Das ist 3x schneller als der Branchendurchschnitt.'
  }, {
    question: 'Was kostet Close CRM?',
    answer: 'Close CRM hat verschiedene Lizenzmodelle ab ca. 25€/Nutzer/Monat. Unsere Implementierungskosten hängen vom gewählten Service-Paket ab. Kontaktieren Sie uns für ein individuelles Angebot.'
  }, {
    question: 'Können Sie Daten aus unserem alten CRM migrieren?',
    answer: 'Ja, wir migrieren Ihre bestehenden Daten aus jedem CRM-System. Im CRM Set Up Paket ist die Migration von bis zu 10.000 Kontakten inklusive.'
  }, {
    question: 'Bieten Sie auch laufenden Support an?',
    answer: 'Ja, unser Managed Service Paket bietet laufenden Priority Support, monatliche Optimierungs-Calls und einen dedizierten Account Manager.'
  }, {
    question: 'Ist Close CRM DSGVO-konform?',
    answer: 'Ja, Close CRM ist vollständig DSGVO-konform. Alle Daten werden sicher in der EU gespeichert mit vollständigem Audit-Trail und Löschfunktionen.'
  }];
  // Review Structured Data
  const reviewData = [{
    author: 'Florian Bretschneider',
    rating: 5,
    text: 'Wir haben das CRM-System mit sämtlichen Prozessen und Automatisierungen. Stehen jetzt bei 510.000 Euro Cash Collect monatlich mit einem Auftragsvolumen von über 800.000 Euro.',
    date: '2024-01-15'
  }, {
    author: 'Albert Pappelheim',
    rating: 5,
    text: 'Wir arbeiten drei- bis viermal effizienter. An einem Tag schaffen wir bestimmt 300-400 Anwahlversuche statt 100-150. Das spart immens viel Zeit.',
    date: '2024-02-20'
  }, {
    author: 'Adrian Wettig',
    rating: 5,
    text: 'Das CRM erleichtert uns das Leben extrem. Wir konnten unseren Umsatz von 30.000€ auf 70.000€ verdoppeln.',
    date: '2024-03-10'
  }];
  // Breadcrumb Structured Data
  const breadcrumbs = [{
    name: 'Home',
    url: 'https://close-crm-agentur.de'
  }];
  const structuredData = [organizationSchema, localBusinessSchema, serviceSchema, websiteSchema, breadcrumbSchema(breadcrumbs), faqSchema(faqData), reviewSchema(reviewData)];
  return <>
      <SEO title="Close CRM Agentur für skalierbaren Vertrieb | 47% mehr Abschlüsse" description="Die führende Close CRM Agentur im deutschsprachigen Raum. Wir implementieren Close CRM so, dass Ihr Vertriebsteam 47% mehr Abschlüsse erzielt – ohne zusätzliche Mitarbeiter, ohne Chaos, ohne Datenverlust. ✓ 110+ Kunden ✓ 3.2x ROI ✓ 2-4 Wochen Implementierung" canonical="https://close-crm-agentur.de" structuredData={structuredData} data-id="element-560" />
      <div className="min-h-screen bg-[#0a0a0a]" data-id="element-561">
        {/* Simple Header with CTA */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-lg border-b border-white/5" data-id="element-562">
          <nav className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-563">
            <div className="flex items-center justify-center sm:justify-between h-14 sm:h-16 lg:h-20 gap-2 sm:gap-4" data-id="element-564">
              {/* Logo */}
              <a href="/" className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0" aria-label="Close CRM Agentur Homepage" data-id="element-565">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[#0ea5e9] flex items-center justify-center flex-shrink-0" data-id="element-566">
                  <span className="text-white font-bold text-xs sm:text-sm" data-id="element-567">
                    C
                  </span>
                </div>
                <span className="text-white font-bold text-sm sm:text-base lg:text-lg whitespace-nowrap" data-id="element-568">
                  Close CRM Agentur
                </span>
              </a>

              {/* CTA Button - Hidden on Mobile */}
              <a href="/Kostenloses-Strategiegespraech" className="hidden sm:flex px-5 py-2.5 bg-[#0ea5e9] text-white font-semibold rounded-lg hover:bg-[#0284c7] transition-colors text-sm items-center justify-center text-center leading-tight flex-shrink-0" data-id="element-569">
                <span className="whitespace-nowrap" data-id="element-570">
                  Kostenloses Strategiegespräch
                </span>
              </a>
            </div>
          </nav>
        </header>

        {/* Main content */}
        <main data-id="element-571">
          <Hero data-id="element-572" />
          <ProblemSection data-id="element-573" />
          <SolutionSection data-id="element-574" />
          <div id="benefits" data-id="element-575">
            <BenefitsGrid data-id="element-576" />
          </div>
          <div id="process" data-id="element-577">
            <ProcessSteps data-id="element-578" />
          </div>
          <ServicesSection data-id="element-579" />
          <CaseStudies data-id="element-580" />
          <Testimonials data-id="element-581" />
          <FAQ data-id="element-582" />
          <FinalCTA data-id="element-583" />
        </main>

        {/* Footer */}
        <footer className="bg-[#0a0a0a] border-t border-white/5 py-12" data-id="element-584">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-585">
            <div className="grid md:grid-cols-4 gap-8" data-id="element-586">
              {/* Brand */}
              <div className="md:col-span-2" data-id="element-587">
                <div className="flex items-center gap-2 mb-4" data-id="element-588">
                  <div className="w-8 h-8 rounded-lg bg-[#0ea5e9] flex items-center justify-center" data-id="element-589">
                    <span className="text-white font-bold text-sm" data-id="element-590">C</span>
                  </div>
                  <span className="text-white font-bold text-lg" data-id="element-591">
                    Close CRM Agentur
                  </span>
                </div>
                <p className="text-gray-500 text-sm max-w-md mb-4" data-id="element-592">
                  Die führende Close CRM Agentur im deutschsprachigen Raum. Wir
                  haben über 110 Unternehmer dabei unterstützt, ihren Vertrieb
                  zu automatisieren und mehr Umsatz zu generieren.
                </p>
                <p className="text-gray-600 text-xs" data-id="element-593">
                  © {new Date().getFullYear()} Close CRM Agentur. Alle Rechte
                  vorbehalten.
                </p>
              </div>

              {/* Links */}
              <div data-id="element-594">
                <h4 className="text-white font-semibold mb-4" data-id="element-595">Navigation</h4>
                <ul className="space-y-2" data-id="element-596">
                  <li data-id="element-597">
                    <a href="#benefits" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-598">
                      Vorteile
                    </a>
                  </li>
                  <li data-id="element-599">
                    <a href="#process" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-600">
                      Prozess
                    </a>
                  </li>
                  <li data-id="element-601">
                    <a href="#services" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-602">
                      Services
                    </a>
                  </li>
                  <li data-id="element-603">
                    <a href="#faq" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-604">
                      FAQ
                    </a>
                  </li>
                </ul>
              </div>

              {/* Contact */}
              <div data-id="element-605">
                <h4 className="text-white font-semibold mb-4" data-id="element-606">Kontakt</h4>
                <ul className="space-y-2 text-sm" data-id="element-607">
                  <li data-id="element-608">
                    <a href="mailto:justus@crm-kraft.de" className="text-gray-500 hover:text-white transition-colors" data-id="element-609">
                      justus@crm-kraft.de
                    </a>
                  </li>
                  <li data-id="element-610">
                    <a href="tel:+4915735999071" className="text-gray-500 hover:text-white transition-colors" data-id="element-611">
                      +49 157 35999071
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Legal links */}
            <div className="mt-12 pt-8 border-t border-white/5 flex flex-wrap gap-6 text-xs text-gray-600" data-id="element-612">
              <a href="/impressum" className="hover:text-white transition-colors" data-id="element-613">
                Impressum
              </a>
              <a href="/datenschutz" className="hover:text-white transition-colors" data-id="element-614">
                Datenschutz
              </a>
            </div>
          </div>
        </footer>
      </div>
    </>;
}